/** @format */

import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: () => import('@/views/login/index.vue'),
    },
    {
        path: '/',
        component: () => import('@/views/home/index.vue'), // 主页面（含左侧导航）
        children: [
            {
                path: 'HomeIndex',
                name: 'HomeIndex',
                component: () => import('@/views/homePage/homeIndex.vue'),
            }, // 默认显示首页
            {
                path:'associated',//关联商品
                component: () =>
                    import('@/views/homePage/components/associated-goods.vue'),
            },
            {
                path:'search',//1688
                component: () =>
                    import('@/views/other-page/search.vue'),
            },
            {
                path:'supply-chain',//1688
                component: () =>
                    import('@/views/other-page/supply-chain.vue'),
            },
            {
                path:'recommend',//1688
                component: () =>
                    import('@/views/other-page/recommend.vue'),
            },
            {
                path:'intelligent',//商品推荐
                component: () =>
                    import('@/views/other-page/intelligent.vue'),
            },
            {
                path:'commodity',//商品推荐
                component: () =>
                    import('@/views/other-page/commodity.vue'),
            },
            {
                path:'association',//商品关联
                component: () =>
                    import('@/views/homePage/components/association.vue'),
            },
            {
                path:'purchaseSettings',//采购设置，快速售后，自动采购,发货设置,自动备注
                name: 'purchaseSettings',
                component: () =>
                    import('@/views/homePage/components/purchase-settings.vue'),
            },
            {
                path:'bulkDistribution',//批量铺货
                component: () =>
                    import('@/views/homePage/components/bulk-distribution.vue'),
            },
            {
                path:'balance',//余额
                component: () =>
                    import('@/views/homePage/components/balance.vue'),
            },
            {
                path:'returnGoods',//退回设置
                component: () =>
                    import('@/views/homePage/components/return-of-goods.vue'),
            },
            {
                path:'orderExplosionPlan',//爆单计划
                component: () =>
                    import('@/views/homePage/components/order-explosion-plan.vue'),
            },
            {
                path:'join-order',//爆单计划--立即加入
                component: () =>
                    import('@/views/homePage/components/join-order.vue'),
            },
            {
                path:'bind-shop',//爆单计划--选择店铺后
                component: () =>
                    import('@/views/homePage/components/bind-shop.vue'),
            },
            {
                path: 'Shop',
                component: () =>
                    import('@/views/shopManage/index.vue'),
            },//店铺管理--菜单
            {
                path: 'returnGoods',
                component: () =>
                    import('@/views/homePage/components/return-of-goods.vue'),

            },//分销退货管理--菜单
            {
                path: 'orderExplosionPlan',
                component: () =>
                    import('@/views/homePage/components/order-explosion-plan.vue'),
            },//爆单计划--菜单
            {
                path: 'Manage',
                component: () =>
                    import('@/views/distributionManage/index.vue'),
            },//铺货管理--菜单
            {
                path: 'Manage-edit',
                component: () =>
                    import('@/views/distributionManage/components/edit.vue'),
            },//铺货管理--菜单--编辑douyinEdit
            {
                path: 'Manage-douyinEdit',
                component: () =>
                    import('@/views/distributionManage/components/douyinEdit.vue'),
            },//铺货管理--菜单--抖音编辑douyinEdit
            {
                path: 'Manage-jingDongEdit',
                component: () =>
                    import('@/views/distributionManage/components/jingDongEdit.vue'),
            },//铺货管理--菜单--京东编辑jingDongEdit
            {
                path: 'Manage-xiaoHongShuEdit',
                component: () =>
                    import('@/views/distributionManage/components/xiaohongshuEdit.vue'),
            },//铺货管理--菜单--小红书编辑xiaohongshu
            {
                path: 'Manage-taobaoEdit',
                component: () =>
                    import('@/views/distributionManage/components/taobaoEdit.vue'),
            },//铺货管理--菜单--淘宝编辑淘宝
            {
                path: 'Manage-match',
                component: () =>
                    import('@/views/distributionManage/components/match.vue'),
            },//铺货管理--菜单--拍一发多
            {
                path: 'bulkDistribution',
                component: () =>
                    import('@/views/homePage/components/bulk-distribution.vue'),
            },//批量上货--菜单
            {
                path:'associated',
                component: () =>
                    import('@/views/homePage/components/associated-goods.vue'),
            },//关联商品（可关联商品）--菜单
            {
                path:'zelated',
                component: () =>
                    import('@/views/homePage/components/no-associated-goods.vue'),
            },//关联商品（已关联商品）--菜单
            {
                path: 'Order',
                component: () =>
                    import('@/views/purchaseManage/list.vue'),
            },//采购单管理（采购单列表）--菜单
            {
                path: 'noLink',
                component: () =>
                    import('@/views/purchaseManage/components/no-link.vue'),
            },//采购单管理（采购单列表）未关联订单设置--菜单
            {
                path: 'relatong',
                component: () =>
                    import('@/views/purchaseManage/order.vue'),
            },//采购单管理（同步订单）--菜单
            {
                path:'profitStatistics',//利润统计
                component: () =>
                    import('@/views/homePage/components/profit-statistics.vue'),
            },//利润统计--菜单
            {
                path: 'distributionGoods',
                component: () =>
                    import('@/views/homePage/components/distribution-goods.vue'),
            }, // 铺货设置--菜单
            {
                path:'Station',
                component: () =>
                    import('@/views/station/index.vue'),
            },//分销小站--菜单
            {
                path: 'supply-chain',
                component: () => import('@/views/products/supper.vue'),
            }, // 1688官方供应链
            // 其他子路由按需求添加
        ],
    },
];

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
});

// 关键新增：全局捕获路由错误
router.onError((error) => {
    if (error.name === 'NavigationDuplicated') {
        // 忽略重复导航错误
        return;
    }
    console.error('路由错误:', error);
});

export default router;
